module.exports = "av/splashscreen.eac80b2e.mp3";